// Older builds cached the logged-in user's profile in localStorage. The app now
// reads it from the API only, so clear whatever those builds left behind.
const LEGACY_USER_KEYS = [
  "login_user_name",
  "login_user_details",
  "login_user_id",
  "login_user_role",
];

export const purgeLegacyUserStorage = () => {
  try {
    LEGACY_USER_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // storage unavailable - nothing to clean up
  }
};
